import { render, staticRenderFns } from "./ModelDataViewer.vue?vue&type=template&id=787a9f23&scoped=true"
import script from "./ModelDataViewer.vue?vue&type=script&lang=js"
export * from "./ModelDataViewer.vue?vue&type=script&lang=js"
import style0 from "./ModelDataViewer.vue?vue&type=style&index=0&id=787a9f23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a9f23",
  null
  
)

export default component.exports